/**
 * Represents the zeus.apollon_fk_conf.conf.kontakte value object - the Foerderkategorie config
 * json structure
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { Model, type MutationsObject } from '@kp/js-model';

export const SICHTBARKEIT = {
    IMMER: null,
    EINREICHUNG: 'einreichung',
    ABSCHLUSS: 'abschluss',
    NIE: 'nie'
};

export class Dokument extends Model {
    public beschreibung: string | null = null
    public ident: string | null = null
    public name: string | null = null
    public order: number | null = null
    public required: boolean = false
    public sichtbarkeit: string | null = null

    public mutations(): MutationsObject {
        return {
            sichtbarkeit: (val: string | null) => {
                if (val === SICHTBARKEIT.ABSCHLUSS || val === SICHTBARKEIT.EINREICHUNG || val === SICHTBARKEIT.NIE) {
                    return val;
                } else {
                    return null;
                }
            }
        };
    }
}

